import { type TypeRouteRef, begatewayRoutesApi, byKey, routeKey } from '@/store/api/begateway/begateway.routes.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeRoute } from '@/types/begateway/types.begateway.route';

export const writeRoute = (dispatch: TypeAppDispatch, route: TypeRoute) => {
    dispatch(begatewayRoutesApi.util.updateQueryData('listGatewayRoutes', undefined, (draft) => {
        const index = draft.items.findIndex((entry) => routeKey(entry) === routeKey(route));
        if (index >= 0) draft.items[index] = route; else draft.items.push(route);
        draft.items.sort(byKey);
    }));
    dispatch(begatewayRoutesApi.util.updateQueryData('readGatewayRoute', { kind: route.kind, name: route.name }, () => route));
    dispatch(begatewayRoutesApi.util.invalidateTags([{ type: 'GatewayAudit', id: routeKey(route) }]));
};

export const dropRoute = (dispatch: TypeAppDispatch, ref: TypeRouteRef) => {
    dispatch(begatewayRoutesApi.util.updateQueryData('listGatewayRoutes', undefined, (draft) => {
        const index = draft.items.findIndex((entry) => routeKey(entry) === routeKey(ref));
        if (index >= 0) draft.items.splice(index, 1);
    }));
    dispatch(begatewayRoutesApi.util.invalidateTags([{ type: 'GatewayRoute', id: routeKey(ref) }, 'GatewayService', 'GatewayAccess', { type: 'GatewayAudit', id: routeKey(ref) }]));
};
